// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__1R_FS","content":"Consent_content__1yYxk","footer":"Consent_footer__pagGn"};